const questionsItem = document.querySelectorAll('.questions-item');
questionsItem.forEach((item) => {
    item.addEventListener('click', () => {
        const parent = item.parentNode;
        if (parent.classList.contains('active')) {
            parent.classList.remove('active');
        } else {
            document.querySelectorAll('.questions-ul li').forEach((child) => child.classList.remove('active'))
            parent.classList.add('active');
        }

    })
})

function parallax(e) {
    this.querySelectorAll('.elements-icon').forEach(layer => {
        const speed = layer.getAttribute('data-speed');
        const x = (window.innerWidth - e.pageX * speed) / 100;
        layer.style.transform = `translateX(${x}px)`;
    })
}
document.addEventListener("mousemove", parallax);

$(function(){
    $('ul.tabs__caption').on('click', 'li:not(.active)', function () {
        $(this)
            .addClass('active').siblings().removeClass('active')
            .closest('div.tabs').find('div.tabs__content').removeClass('active').eq($(this).index()).addClass('active');
    });

    $('.messageShow3').hide();
    $('.messageGood3').hide();
    $("#done3").click(function (e) {
        e.preventDefault();
        var bonusphone = $("#bonusphone").val();
        var fail = "";
        if (bonusphone.length < 1) {
            // $("#phone").addClass("_error");
            // $("#name").removeClass("_error");
            fail = "Напишите номер телефона";
        }
        // else if(phone.search(/^\d{1}\s\(\d{3}\)\s\d{3}\-\d{2}\-\d{2}/) == -1) {
        //   $("#phone").removeClass("_error");
        //   fail = "Вы ввели неправильный номер телефона";}
        if (fail != "") {
            $('.messageShow3').html(fail);
            $('.messageShow3').show();
            $('.messageGood3').hide();

        }

        var cur_button = $(this);

        if (!cur_button.hasClass('ajax_start') && !fail) {
            cur_button.addClass('ajax_start');

            $.ajax({
                url: '/d/js/ajax/feedback3.php',
                type: 'POST',
                cache: false,
                data: {'bonusphone': bonusphone},
                dataType: 'html',
                success: function (data) {
                    $("#bonusphone").val('');
                    $('.messageShow3').hide();
                    $('.messageGood3').html(data);
                    $('.messageGood3').show();
                    cur_button.removeClass('ajax_start');
                }
            });
        }
    });

    if ($('.typed-text').length > 0) {
        var typed = new Typed('.typed-text', {
            strings: ['полного цикла', 'работает на результат', 'для лидеров рынка'],
            typeSpeed: 60,
            backSpeed: 20,
            startDelay: 500,
            loop: true
        });
    }

    $('a[href*=\\#]').bind("click", function (e) {
        var anchor = $(this);
        $('html, body').stop().animate({
            scrollTop: $(anchor.attr('href')).offset().top
        }, 1000);
        e.preventDefault();
        return false;
    });
    document.querySelectorAll('.form-footer form label input, .form-footer form label textarea').forEach((item) => {
        let parent = item.parentNode;
        item.addEventListener('focus', function () {
            parent.classList.add('form-footer_labelActive');
        });
        item.addEventListener('blur', function () {
            parent.classList.remove('form-footer_labelActive');
        });
    })

    $(".burger-menu").click(function () {
        $(".mob-menu").addClass("on");
        return false;
    });
    $(".closex").click(function () {
        $(".mob-menu").removeClass("on");
        return false;
    });
    $(window).resize(function () {
        var wid = $(window).width();
        var menu = $('.mob-menu');
        if (wid > 1000) {
            $(".mob-menu").removeClass("on");
        }
    });
});

var services_swiper = new Swiper('.services__slider', {
    slidesPerView: 1,
    spaceBetween: 0,
    // autoplay: {
    //     delay: 4500,
    //     disableOnInteraction: false,
    // },
    autoplay:false,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 10,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 10,
        },
    }
});

var gallery_swiper = new Swiper('.content__text_gallery', {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
        el: '.swiper-pagination',
        clickable: true,
    },
    autoplay: {
        delay: 4500,
        disableOnInteraction: false,
    },
    breakpoints: {
        768: {
            slidesPerView: 3,
        },
        1024: {
            slidesPerView: 4,
        },
    }
});

$('.ourValues__header_slider').each(function(){
    var ourValues_swiper = new Swiper(this, {
        slidesPerView: 1, 
        spaceBetween: 30, 
        loop: true, 
        autoplay: {
            delay: 4500,
            disableOnInteraction: false,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
        }
    });

    var prev_control = $(this).parents('.ourValues').find('.ourValues__prev');
    var next_control = $(this).parents('.ourValues').find('.ourValues__next');
    if(prev_control.length)
        prev_control[0].swiper = ourValues_swiper;
    if(next_control.length)
        next_control[0].swiper = ourValues_swiper;
});

$(document).on('click', '.ourValues__prev', function(){
    if(this.swiper)
        this.swiper.slidePrev();
});
$(document).on('click', '.ourValues__next', function(){
    if(this.swiper)
        this.swiper.slideNext();
});

var trustus_swiper = new Swiper('.trustus-slider', {
    slidesPerView: 'auto', 
    centeredSlides: true, 
    loop: true, 
    spaceBetween: 15,
    autoplay:false
});

function togglePopup(in_structure_id) {
    in_structure_id = in_structure_id || 0;
    get_popup_claim_block(2,in_structure_id);
}

//Загрузить полную версию отзыва.
$(document).on('click', '.get_feedback', function(){
    var feedback_id = $(this).data('feedback');
    incube_ajax('faq', 'html', 'get_feedback', {'id': feedback_id}, function(html){
        $.fancybox.open(html);
    });
});

/*Прокрутка вверх страницы*/
$(document).on('click', '.to_top_button', function () {
    $('body,html').animate({
        scrollTop: 0
    }, 500);
    
    return false; 
});

/*Появление / исчезновение кнопки "Наверх".*/
$(window).on('scroll resize', function(){
    if ($(this).scrollTop() > 100){ 
        $('.to_top_button').fadeIn(); 
    }else{
        $('.to_top_button').fadeOut(100);
    }
});
function tariff_tab_mobile(tariff_id,el){
    if(!$(el).hasClass('active')){
        $(el).addClass('active');
        $(el).siblings('button').removeClass('active');
        $('.tariff-mobile__box').removeClass('active');
        $('#tariff-'+tariff_id).addClass('active');
    }
}


//Фиксация меню сверху страницы. 
var scrollPos = 0;
$(window).scroll(function(){
    var st = $(this).scrollTop();

    var header_margin_height = $('#header_margin').outerHeight();
    var header_height = $('#header_fixed').outerHeight();

    if(st>header_margin_height+header_height)
        $('body').addClass('fix_header');
    if(st<header_margin_height)
        $('body').removeClass('fix_header');

    if (st > scrollPos)
        $('body').addClass('scrolled_down').removeClass('scrolled_up');
    else
        $('body').addClass('scrolled_up').removeClass('scrolled_down');

    scrollPos = st;
});


$(document).on('click', '.tariff_column .top', function(){
    $(this).parents('.tariff_column').toggleClass('opened');
});